module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-411x93px.c73307ca.jpg";